module.exports = __webpack_public_path__ + "img/sms-code.cfa97879.svg";